// Simple QR Code generator using qrcode.js library
// You can install it with: npm install qrcode

import QRCode from 'qrcode';

/**
 * Generate QR code as data URL for UPI payment
 * @param {string} upiString - UPI payment string
 * @returns {Promise<string>} Data URL of the QR code
 */
export const generateUPIQRCode = async (upiString) => {
  try {
    const qrDataURL = await QRCode.toDataURL(upiString, {
      width: 200,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      },
      errorCorrectionLevel: 'M'
    });
    return qrDataURL;
  } catch (error) {
    console.error('Error generating QR code:', error);
    return null;
  }
};

/**
 * Generate QR code as Canvas element
 * @param {HTMLCanvasElement} canvas - Canvas element to render QR code
 * @param {string} upiString - UPI payment string
 * @returns {Promise<boolean>} Success status
 */
export const generateUPIQRCodeToCanvas = async (canvas, upiString) => {
  try {
    await QRCode.toCanvas(canvas, upiString, {
      width: 200,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      },
      errorCorrectionLevel: 'M'
    });
    return true;
  } catch (error) {
    console.error('Error generating QR code to canvas:', error);
    return false;
  }
};

/**
 * Fallback QR code using Google Charts API (no additional dependencies)
 * @param {string} upiString - UPI payment string
 * @param {number} size - QR code size in pixels
 * @returns {string} Google Charts QR code URL
 */
export const generateGoogleQRCode = (upiString, size = 200) => {
  const encodedData = encodeURIComponent(upiString);
  return `https://chart.googleapis.com/chart?chs=${size}x${size}&cht=qr&chl=${encodedData}&choe=UTF-8`;
};

export default {
  generateUPIQRCode,
  generateUPIQRCodeToCanvas,
  generateGoogleQRCode
};